import { companyApi } from "./company.api";

export const { useGetCompanyByHostQuery, useGetCompaniesQuery, useLazyGetCompanyByHostQuery } = companyApi;
